import { render, staticRenderFns } from "./SportHeader.vue?vue&type=template&id=20e23602&scoped=true"
import script from "./SportHeader.vue?vue&type=script&lang=js"
export * from "./SportHeader.vue?vue&type=script&lang=js"
import style0 from "./SportHeader.vue?vue&type=style&index=0&id=20e23602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e23602",
  null
  
)

export default component.exports